import React, { useEffect, useState } from 'react'
import { Col, Panel, Row } from 'rsuite'
import EditFormWidget from '../../projectProposal/dynamicForm/EditFormWidget'
import InputRadioForm from '../../../components/forms/input/InputRadioForm'

export default function SubProjectAddressInput({
  schema,
  shaded,
  bordered,
  collapsible,
  defaultExpanded,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  disabled,
  setIsLoading = () => {},
  ...props
}) {
  // const {  } = props
  const [sameAddress, setSameAddress] = useState(schema?.sameAddress?.value || '0')

  useEffect(() => {
    if (schema?.sameAddress) {
      setSameAddress(schema.sameAddress.value || '0')
    } else {
      setSameAddress('0')
    }
  }, [schema])

  return (
    <>
      {schema && (
        <Panel
          header={schema.header}
          shaded={shaded}
          bordered={bordered}
          collapsible={collapsible}
          defaultExpanded={defaultExpanded}
          style={{ marginTop: 10 }}
        >
          <div style={{ marginTop: -20 }}>
            {schema.sameAddress && (
              <Panel style={{ marginBottom: -20 }}>
                <Row>
                  <Col>
                    <InputRadioForm
                      inline
                      schema={schema.sameAddress}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      onChange={(value) => {
                        console.log(value)
                        setSameAddress(value)
                      }}
                      value={sameAddress}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
              </Panel>
            )}

            {sameAddress == '0' && (
              <EditFormWidget
                schema={schema}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                setLoading={setIsLoading}
                disabled={disabled}
              />
            )}
          </div>
        </Panel>
      )}
    </>
  )
}
